<template>
  <div>
    <div class="navbar-box">
      <van-nav-bar
        :title="text"
        @click-left="onClickLeft"
        @click-right="onClickRight"
      >
        <template #left>
          <van-icon color="#200E32" name="arrow-left" size="22" />
        </template>
        <template #right>
          <van-icon color="#200E32" name="wap-nav" size="22" />
        </template>
      </van-nav-bar>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      text: "标题",
    };
  },
  methods: {
    onClickLeft() {
      console.log("返回");
    },
    onClickRight() {
      console.log("按钮");
    },
  },
};
</script>

<style scoped>
.menu-icon {
  width: 26px;
  height: 26px;
  position: absolute;
  top: 11px;
  right: 16px;
  z-index: 99;
}
.navbar-box {
  position: fixed;
  top: 0;
  width: 100%;
}
</style>
